<script setup lang="ts">
interface ILoaderProps {
  size?: string
  color?: string
}
const props = withDefaults(defineProps<ILoaderProps>(), {
  size: 'small',
  color: 'default'
})

const {
  size,
  color
} = toRefs(props)
</script>

<template>
  <div :class="`cloader cloader--active spinner cloader--js-btn cloader--${color} cloader--${size}`"><div/><div/><div/><div/></div>
</template>
